import type { ButtonHTMLAttributes, ReactNode } from 'react';
import { Link, type LinkProps } from 'react-router';

export type ButtonVariant = 'primary' | 'secondary' | 'danger' | 'danger-outline' | 'ghost';

interface Common {
  variant?: ButtonVariant;
  size?: 'md' | 'sm';
  block?: boolean;
  icon?: ReactNode;
}

const cls = ({ variant = 'primary', size = 'md', block }: Common, extra?: string) =>
  ['btn', `btn-${variant}`, size === 'sm' ? 'sm' : '', block ? 'block' : '', extra ?? '']
    .filter(Boolean)
    .join(' ');

export function Button({
  variant,
  size,
  block,
  icon,
  loading,
  className,
  children,
  disabled,
  type = 'button',
  ...rest
}: Common & ButtonHTMLAttributes<HTMLButtonElement> & { loading?: boolean }) {
  return (
    <button
      type={type}
      className={cls({ variant, size, block }, className)}
      disabled={disabled || loading}
      aria-busy={loading || undefined}
      {...rest}
    >
      {loading ? <span className="spinner" style={{ width: 14, height: 14 }} aria-hidden /> : icon}
      {children}
    </button>
  );
}

export function LinkButton({
  variant = 'secondary',
  size,
  block,
  icon,
  className,
  children,
  ...rest
}: Common & LinkProps) {
  return (
    <Link className={cls({ variant, size, block }, className)} {...rest}>
      {icon}
      {children}
    </Link>
  );
}
